/* ==========================================================================
   Cloud Store CBD — Pages collections « comparatif d'abord » (refonte 2026-09-28)
   1. Relevé : repli « Voir les … », tri par colonne avec réordonnancement FLIP (220 ms,
      statique en prefers-reduced-motion). Sans JS, tout le relevé est visible.
   2. Carte allégée (grille --compact, mobile) : le bouton panier ouvre l'ajout rapide
      (choix du grammage) au lieu d'ajouter le premier format sans le montrer.
   ========================================================================== */
(function () {
  if (window.__csCollInit) return;
  window.__csCollInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 749px)');
  var EASE = 'cubic-bezier(.16, 1, .3, 1)';

  function rowsOf(rel) {
    var body = rel.querySelector('[data-cs-rel-body]');
    return body ? Array.prototype.slice.call(body.children) : [];
  }

  function applyVisible(rel) {
    var n = parseInt(rel.getAttribute('data-visible'), 10) || 5;
    rowsOf(rel).forEach(function (tr, i) { tr.classList.toggle('is-extra', i >= n); });
  }

  function isShown(tr) { return tr.getClientRects().length > 0; }

  function initRel(rel) {
    if (rel.__csInit) return;
    rel.__csInit = true;
    rowsOf(rel).forEach(function (tr, i) { tr.setAttribute('data-idx', i); });
    var more = rel.querySelector('[data-cs-rel-more]');
    if (more) {
      rel.classList.add('is-collapsible');
      more.hidden = false;
      applyVisible(rel);
    }
  }

  function num(tr, key) {
    var v = parseFloat(tr.getAttribute('data-' + key));
    return isNaN(v) ? 0 : v;
  }

  function sortRel(rel, key, dir) {
    var body = rel.querySelector('[data-cs-rel-body]');
    if (!body) return;
    var rows = rowsOf(rel);

    /* First : positions des lignes visibles avant le tri */
    var first = new Map();
    rows.forEach(function (tr) { if (isShown(tr)) first.set(tr, tr.getBoundingClientRect().top); });

    var sorted = rows.slice().sort(function (a, b) {
      var ao = a.classList.contains('is-out') ? 1 : 0;
      var bo = b.classList.contains('is-out') ? 1 : 0;
      if (ao !== bo) return ao - bo;
      var ai = num(a, 'idx'), bi = num(b, 'idx');
      if (key === 'idx') return ai - bi;
      var av = num(a, key), bv = num(b, key);
      if (!av && bv) return 1;   /* valeur absente : en bas */
      if (av && !bv) return -1;
      if (av === bv) return ai - bi;
      return dir === 'asc' ? av - bv : bv - av;
    });
    sorted.forEach(function (tr) { body.appendChild(tr); });
    if (rel.classList.contains('is-collapsible')) applyVisible(rel);

    if (reduceMotion.matches) return;

    /* Last + Invert + Play */
    var moved = [];
    sorted.forEach(function (tr) {
      if (!isShown(tr)) return;
      if (!first.has(tr)) {
        tr.classList.remove('is-entering');
        void tr.offsetWidth;
        tr.classList.add('is-entering');
        return;
      }
      var dy = first.get(tr) - tr.getBoundingClientRect().top;
      if (Math.abs(dy) < 1) return;
      tr.style.transition = 'none';
      tr.style.transform = 'translateY(' + dy + 'px)';
      moved.push(tr);
    });
    if (!moved.length) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        moved.forEach(function (tr) {
          tr.style.transition = 'transform 220ms ' + EASE;
          tr.style.transform = '';
          tr.addEventListener('transitionend', function clean() {
            tr.style.transition = '';
            tr.removeEventListener('transitionend', clean);
          });
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cs-rel-sort]');
    if (chip) {
      var rel = chip.closest('[data-cs-rel]');
      if (!rel || chip.getAttribute('aria-pressed') === 'true') return;
      rel.querySelectorAll('[data-cs-rel-sort]').forEach(function (c) {
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      sortRel(rel, chip.getAttribute('data-cs-rel-sort'), chip.getAttribute('data-dir') || 'desc');
      return;
    }

    var more = e.target.closest('[data-cs-rel-more]');
    if (more) {
      var rel2 = more.closest('[data-cs-rel]');
      if (!rel2) return;
      var open = !rel2.classList.contains('is-open');
      var before = new Set(rowsOf(rel2).filter(isShown));
      rel2.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? more.getAttribute('data-label-less') : more.getAttribute('data-label-more');
      if (open && !reduceMotion.matches) {
        rowsOf(rel2).forEach(function (tr) {
          if (!before.has(tr) && isShown(tr)) tr.classList.add('is-entering');
        });
      }
      if (!open) {
        var top = rel2.getBoundingClientRect().top;
        if (top < 0) rel2.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }
  });

  document.addEventListener('animationend', function (e) {
    if (e.target.classList && e.target.classList.contains('is-entering')) e.target.classList.remove('is-entering');
  });

  /* Carte allégée : phase de capture, pour passer avant l'ajout direct de cs-product-card. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cs-collection-grid--compact [data-cs-card-add][data-cs-add-mode="grams"]');
    if (!btn || !mobile.matches || typeof window.csOpenQuickAddModal !== 'function') return;
    var card = btn.closest('.cs-product-card');
    var json = card && card.querySelector('[data-cs-card-product]');
    if (!json) return;
    var prod;
    try { prod = JSON.parse(json.textContent); } catch (err) { return; }
    e.preventDefault();
    e.stopPropagation();
    window.csOpenQuickAddModal(prod, btn);
  }, true);

  function init() {
    document.querySelectorAll('[data-cs-rel]').forEach(initRel);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
